module.exports = __webpack_public_path__ + "static/media/idleMobileImage.945d0d26.png";